import { apiClient } from "@/shared/api/client";
import {
    GetSlotInfoDefaultsResponseDto,
    GetSlotPoliciesResponseDto,
    SaveSlotPolicyRequest,
} from "@/features/policy/slotManagement/types/slotPolicy.types";

const BASE_PATH = '/api/v1/slot-policy';

export const slotPolicyApi = {
    getSlotPolicies: async (): Promise<GetSlotPoliciesResponseDto> => {
        const response = await apiClient.get<GetSlotPoliciesResponseDto>(BASE_PATH);
        return response.data;
    },

    saveSlotPolicy: async (request: SaveSlotPolicyRequest): Promise<void> => {
        await apiClient.post<void>(BASE_PATH, request);
    },

    deleteSlotPolicy: async (seqNo: number): Promise<void> => {
        await apiClient.delete<void>(`${BASE_PATH}/${seqNo}`);
    },

    getSlotInfoDefaults: async (): Promise<GetSlotInfoDefaultsResponseDto> => {
        const response = await apiClient.get<GetSlotInfoDefaultsResponseDto>(
            '/api/v1/common-code/list',
            { params: { grpCode: 'SLOTINFO' } }
        );
        return response.data;
    },
};
